import { useQuery } from "react-query";
import { useSearchParams } from "react-router-dom";
import { useApiAccess } from "./useApiAccess";
import { getCategoryBySlugs } from "../../Service/CategoryService";
import { queryKeys } from "./queryKeys";

export function useCategoryBySlugs(slugs = []) {
  const hasAccess = useApiAccess();
  const [searchParams] = useSearchParams();
  const productParam = searchParams.get("product");

  const pathParams = { ...(productParam && { product: productParam }) };
  const categorySlugs = slugs.filter((slug) => slug?.length > 0);

  return useQuery(
    queryKeys.categoryBySlugs(categorySlugs, productParam),
    () => getCategoryBySlugs({ categorySlugs }, pathParams),
    { enabled: !!hasAccess && categorySlugs.length > 0 }
  );
}
